(app => {

    app.service("pipelinesDataTable",
        [
            "$state", "pipelineModalService", "pipelineApi", function($state, pipelineModalService, pipelineApi) {
                this.dataTableOptions = {
                    title: "Pipelines",
                    headers: [
                        {
                            title: "Name",
                            type: "string",
                        },
                        {
                            title: "Date Created",
                            type: "date",
                        },
                        {
                            title: "Total Pipes",
                            type: "string",
                        },
                        {
                            title: "Total Contacts",
                            type: "string",
                        }
                    ],
                };

                this.buildDataTableOptions = (pipelines) => {
                    this.dataTableOptions = {
                        ...this.dataTableOptions,
                        rows: pipelines.map(pipeline => {
                            return {
                                cells: [
                                    pipeline.Name,
                                    pipeline.CreatedOn,
                                    pipeline.TotalPipes,
                                    pipeline.TotalEnrollments,
                                ],
                                rowObject: pipeline,
                                state: {
                                    name: "Home.Marketing.Pipeline",
                                    params: { pipelineId: pipeline.PipelineId },
                                },
                            };
                        }),
                        rowActions: [
                            {
                                title: "Delete pipeline",
                                iconName: "mdi-delete",
                                className: "btn-warning",
                                action: this.deletePipeline,
                            },
                        ],
                        miscButtons: [
                            {
                                label: "Add New Pipeline",
                                action: this.addPipeline,
                            },
                        ],
                    };

                    return this.dataTableOptions;
                }

                this.deletePipeline = (pipeline, $event) => {
                    pipelineModalService.confirmPipelineDeletion($event).then(() => {
                        const rowIndex = this.dataTableOptions.rows.findIndex(row => {
                            return row.rowObject.Id === pipeline.Id;
                        });

                        this.dataTableOptions.rows.splice(rowIndex, 1);

                        pipelineApi.delete(pipeline.PipelineId);
                    });
                }

                this.addPipeline = ($event) => {
                    pipelineModalService.openAddPipeline($event);
                }
            }
        ]);

})(window.app);